import { GetWorkRefusalRequestDetailsResponse } from 'api/laborerPortalAPI/workRefusalRequests'
import { CallAPIAction, Status } from 'api/types'
import {
  convertWorkRefusalRequestDetailsFromResponse,
  WorkRefusalRequestDetails,
} from 'common/utils/convertResponse/convertWorkRefusalRequestResponse'
import Actions from 'redux/actions'

type State = {
  request: WorkRefusalRequestDetails | null
  token: string | null
} & Status

const initialState: State = {
  request: null,
  token: null,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_ASYNC,
    Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_SUCCESS,
    Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_FAIL,
    GetWorkRefusalRequestDetailsResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.status,
        request: convertWorkRefusalRequestDetailsFromResponse(action.payload.data),
        token: action.payload.token,
      }
    case Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_ASYNC:
    case Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
